var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"input",attrs:{"value":_vm.value},nativeOn:{"input":function($event){return _vm.onInput.apply(null, arguments)}}},'v-text-field',_vm.attributes,false))
}
var staticRenderFns = []

export { render, staticRenderFns }